import { biStrategy } from './biStrategy/biStrategy';
import { experimentStrategy } from './experimentStrategy/experimentStrategy';
import urlResolutionStrategy from './urlResolutionStrategy/urlResolutionStrategy';
import pollsStrategy from './pollsStrategy/pollsStrategy';
import { merge } from 'lodash';
import { parseInstance, hasPlugin as hasPluginInPlugins } from './services';
import { POLL_TYPE } from 'wix-rich-content-common';
export var runStrategies = function (_a) {
    var experiments = _a.experiments, plugins = _a.plugins, instance = _a.instance, wixRicosVersion = _a.wixRicosVersion, biSettings = _a.biSettings;
    var hasPlugin = function (pluginType) { return hasPluginInPlugins(pluginType, plugins); };
    var _b = parseInstance(instance), metaSiteId = _b.metaSiteId, appDefId = _b.appDefId;
    var _c = experimentStrategy(experiments), ricosFeatures = _c.ricosFeatures, wixRicosFeatures = _c.wixRicosFeatures;
    return merge({ experiments: ricosFeatures }, biStrategy(appDefId, metaSiteId, wixRicosVersion, biSettings, wixRicosFeatures), urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures), hasPlugin(POLL_TYPE) && pollsStrategy(instance, wixRicosFeatures));
};
//# sourceMappingURL=runStrategies.js.map